module.exports = __webpack_public_path__ + "static/media/web-2.bdbed7ae.jpg";